import React from "react";
import { Link } from "react-router-dom";

const LiveAuctionLoader = ({ message = "Preparing live auction...", subtext }) => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header - matches live auction page */}
      <div className="hidden lg:block live-auction-list">
        <div className="w-[15.5] flex flex-col pt-[20vh]">
          <div className="text-[2.6vw] font-semibold text-white">Live Auction</div>
          <div className="text-white flex gap-3 justify-center text-[1vw] font-urbanist">
            <Link to="/">
              <button className="hover:text-white hover:scale-110 duration-150">
                Home
              </button>
            </Link>
            /
            <button className="hover:text-white hover:scale-110 duration-150">
              Live Auction
            </button>
          </div>
        </div>
      </div>

      {/* Mobile header */}
      <div className="lg:hidden bg-gradient-to-b from-gray-800 to-gray-900 pt-24 pb-8 px-4">
        <div className="text-white text-center font-urbanist">
          <h1 className="text-2xl font-semibold">Live Auction</h1>
          <div className="flex justify-center gap-2 mt-2 text-sm text-gray-300">
            <Link to="/" className="hover:text-white">
              Home
            </Link>
            <span>/</span>
            <span>Live Auction</span>
          </div>
        </div>
      </div>

      {/* Loader content - centered */}
      <div
        className="flex flex-col items-center justify-center px-4 py-16 lg:py-24 lg:min-h-[60vh]"
        role="status"
        aria-live="polite"
        aria-label={message}
      >
        {/* Animated rings + center icon */}
        <div className="relative w-24 h-24 lg:w-28 lg:h-28 mb-8">
          <div className="absolute inset-0 rounded-full border-4 border-red-100 animate-ping opacity-60" />
          <div className="absolute inset-0 rounded-full border-4 border-red-200 animate-pulse" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-11 h-11 lg:w-14 lg:h-14 rounded-full bg-[#CA0000] flex items-center justify-center shadow-lg animate-pulse">
              <svg
                className="w-5 h-5 lg:w-6 lg:h-6 text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M12 2L9 8h6l-3 6 3 6 3-6H9l3-6z" />
              </svg>
            </div>
          </div>
        </div>

        {/* Message */}
        <p className="text-gray-800 font-semibold text-lg lg:text-xl text-center mb-1">
          {message}
        </p>
        {subtext && (
          <p className="text-gray-500 text-sm lg:text-base text-center max-w-sm">
            {subtext}
          </p>
        )}

        {/* Staggered progress dots */}
        <div className="flex gap-2 mt-2" aria-hidden="true">
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="w-2 h-2 rounded-full bg-[#CA0000] opacity-70 animate-bounce"
              style={{ animationDelay: `${i * 0.15}s` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LiveAuctionLoader;
